import { useInheritedColor } from '@nivo/colors';

interface styleConfigProps {
  LabelTextColorControl: {
    from: string,
    modifiers: [['brighter' | 'darker' | 'opacity', number]]
  };
  LabelsFontSizeControl: { value: number };
  LabelsFontFamilyControl: { value: string };
  LabelTranslateX: number;
  LabelTranslateY: number;
  LabelRotationControl: number;
}

interface Arc {
  innerRadius: number;
  outerRadius: number;
  startAngle: number;
  endAngle: number;
}

interface globalConfigProps {
  useGlobalFont: boolean;
  fontLabel: string;
}

interface Dt {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  data: Record<string, any>;
  arc: Arc;
}

interface CustomLabelProps {
  data: Dt[];
  center: [number, number];
  styleConfig: styleConfigProps;
  globalConfig: globalConfigProps;
  content: (dt: Dt['data'], x: number) => React.ReactNode;
}

const CustomLabel = ({
  data, center, styleConfig, globalConfig, content,
}: CustomLabelProps) => {
  const {
    LabelTextColorControl,
    LabelsFontSizeControl,
    LabelsFontFamilyControl,
    LabelTranslateX,
    LabelTranslateY,
    LabelRotationControl,
  } = styleConfig;
  const getColor = useInheritedColor(LabelTextColorControl);

  const getPosX = ({
    innerRadius, outerRadius, startAngle, endAngle,
  }: Arc) => (
    ((innerRadius + outerRadius) / 2) * (Math.cos((startAngle + endAngle) / 2 - Math.PI / 2))
  );
  const getPosY = ({
    innerRadius, outerRadius, startAngle, endAngle,
  }: Arc) => (
    ((innerRadius + outerRadius) / 2) * (Math.sin((startAngle + endAngle) / 2 - Math.PI / 2))
  );

  return data.map((dt) => (
    <g
      key={dt.id}
      transform={`translate(${center[0]}, ${center[1]})`}
    >
      <g
        transform={`translate(${getPosX(dt.arc)}, ${getPosY(dt.arc)})`}
      >
        <text
          // x={dt.width / 2}
          // y={dt.height / 2}
          textAnchor="middle"
          dominantBaseline="central"
          fillOpacity={1}
          style={{
            fontSize: `${LabelsFontSizeControl ? LabelsFontSizeControl.value : 13}px`,
            fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontLabel : LabelsFontFamilyControl?.value}', Arial`,
            transform: `translate(${LabelTranslateX || 0}px, ${LabelTranslateY || 0}px) rotate(${LabelRotationControl || 0}deg)`,
            transformOrigin: 'center center',
            transformBox: 'fill-box',
            pointerEvents: 'none',
            fill: getColor(dt),
          }}
        >
          {content(dt, 0)}
        </text>
      </g>
    </g>
  ));
};

export default CustomLabel;
